import type { TmsInvoiceSendResult } from '@numeo/types-main-web-app'

interface EmailResultsTableProps {
    results: TmsInvoiceSendResult[]
}

/** The invoices a send put out, one row each: the invoice, who it went to, and whether it was sent. */
export const EmailResultsTable = ({ results }: EmailResultsTableProps) => (
    <div className="my-2 overflow-x-auto rounded-xl border border-border">
        <table aria-label="Invoice emails" className="w-full text-xs">
            <thead className="bg-surface-secondary text-foreground-muted">
                <tr>
                    <th className="px-3 py-2 text-left font-medium">Invoice</th>
                    <th className="px-3 py-2 text-left font-medium">Recipient</th>
                    <th className="px-3 py-2 text-left font-medium">Status</th>
                </tr>
            </thead>
            <tbody>
                {results.map((result) => {
                    const sent = result.outcome === 'updated'
                    return (
                        <tr key={`${result.invoice_number}-${result.as_of}`} className="border-t border-border">
                            <td className="px-3 py-2">{result.invoice_number}</td>
                            <td className="px-3 py-2">{result.to.join(', ') || 'Billing email on the rate con'}</td>
                            <td className={`px-3 py-2 ${sent ? 'text-success' : 'text-danger'}`}>{sent ? 'Sent' : (result.message ?? 'Not sent')}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
)
